import React from 'react'

import { connect } from 'react-redux'

import Row from "./row"
import AddRow from "./addRow";

import {selectRow} from "../../actions/index";


const Footer = ({ footer, row, handleRowSelection }) => (
    <div style={{border: "dashed 1px lightgray", padding: "5px"}}>
        <span style={{textDecoration: "underline"}}>Footer</span>
        {footer.map((content, index) => (
        <div key={index}>
            <Row 
                content={content}
                id={content.id} 
                selected={row.selected === content.id}
                onSelection={handleRowSelection}
                parentIndex={index}
                sectionName="footer"
            />
        </div>
        ))}
        <AddRow list={footer} 
            lastRowId={footer.length > 0 ? footer[footer.length - 1].id : 'design_footer_1'}/>
    </div>
);

const mapStateToProps = (state) => {
    return { footer: state.design.footer, row: state.row }
}

const mapDispatchToProps = dispatch => {
    return {
        handleRowSelection: id => {
            dispatch(selectRow(id))
        }
    }
  }

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Footer)